import { Hidden } from "@mui/material";
import HomeSecondSection from "./HomeSecondSection";
import ServiceList from "./ServiceList";

export default function Home() {
    return (
        <div className="flex flex-col md:flex-row justify-between items-center">
            <ServiceList />
            <Hidden smDown>
                <HomeSecondSection />
            </Hidden>
        </div>
    )
}
